module.exports = __webpack_public_path__ + "static/media/ilustracion3.630326ba.png";